import React from "react";
import Footer from "../../components/Landing/Footer";
import Navbar from "../../components/Landing/LandingNavbar";
import policy from "../../constant/policy.json";

const RefundAndCancellation = () => {
  return (
    <div>
      <Navbar />
      <div className="text-center my-6 space-y-4">
        <h1 className="text-5xl font-bold">
          <span className="text-my-blue"> Refund And </span> Cancellation
        </h1>
      </div>
      <div className="my-16 ">
        <div className="container space-y-2 mb-6">
          {/* <h2 className="font-bold text-xl ">Introduction</h2> */}
          <p className="font-light  text-my-gray3 text-base leading-5">
            Thank you for choosing Tootler.ai as your preferred SAAS product. We
            strive to provide our customers with a seamless and satisfactory
            experience. However, we understand that circumstances may arise
            where you need to cancel your subscription. This cancellation and
            refund policy outlines the procedures and guidelines for
            subscription cancellation and potential refunds.
          </p>
        </div>

        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl ">Subscription Cancellation::</h2>

          <ul className="font-light text-my-gray3 text-base leading-5 ">
            <li>
              Users have the option to cancel their subscription to Tootler.ai
              at any time. The cancellation process is straightforward and can
              be done through the user account settings on the Tootler.ai
              platform.
            </li>
          </ul>
        </div>

        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl ">Cancellation Effective Date::</h2>
          <p className="font-light  text-my-gray3 text-base leading-5">
            {" "}
            If a subscription is canceled, the service will continue to be
            accessible until the end of the current billing cycle. This means
            you will have access to Tootler.ai until the last day of your active
            subscription period.
          </p>
        </div>

        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl ">Immediate Cancellation::</h2>
          <p className="font-light  text-my-gray3 text-base leading-5">
            {" "}
            Tootler.ai offers immediate cancellation for users who wish to stop
            their subscription without waiting for the end of the billing cycle.
            However, please note that immediate cancellations are subject to
            certain conditions.
          </p>
        </div>

        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl ">7-Day Cancellation Limit:</h2>
          <p className="font-light  text-my-gray3 text-base leading-5">
            {" "}
            Tootler.ai allows immediate cancellations only within 7 days of the
            initial subscription date. If a user wishes to cancel after the
            7-day period, the cancellation will be effective at the end of the
            current billing cycle.
          </p>
        </div>

        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl ">Fair Usage Limit:</h2>
          <p className="font-light  text-my-gray3 text-base leading-5">
            {" "}
            In the case of immediate cancellations, users should be aware of the
            Fair Usage Limit. The Fair Usage Limit is set at 10% of the total
            usage allowed under the subscribed plan. If a user exceeds this 10%
            limit within the 7-day period, they will not be eligible for an
            immediate cancellation and will need to wait until the end of the
            billing cycle for the cancellation to take effect.
          </p>
        </div>

        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl ">
            Refunds for Immediate Cancellations::
          </h2>
          <p className="font-light  text-my-gray3 text-base leading-5">
            {" "}
            If a user cancels their subscription immediately within the first 7
            days and has not crossed the 10% Fair Usage Limit, they will be
            eligible for a refund. The refund will be issued for the remaining
            unused days of the current billing cycle. To cancel the subscription
            immediately please send an email to hello@tootler.ai
          </p>
        </div>

        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl ">
            Refunds for Regular Cancellations:
          </h2>
          <p className="font-light  text-my-gray3 text-base leading-5">
            {" "}
            For regular cancellations, where the subscription is terminated at
            the end of the billing cycle, no refunds will be provided for the
            unused portion of the subscription since the subscription is being
            cancelled after completion of the billing period
          </p>
        </div>

        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl ">Refund Process:</h2>
          <p className="font-light  text-my-gray3 text-base leading-5">
            Refunds, if applicable, will be processed within 10 business days
            after the cancellation request is approved. The amount refunded will
            be based on the prorated value of the unused subscription days.
          </p>
        </div>

        <div className="container space-y-2 mb-6">
          <h2 className="font-bold text-xl ">Modifications to the Policy:</h2>
          <p className="font-light  text-my-gray3 text-base leading-5">
            Tootler.ai reserves the right to modify the cancellation and refund
            policy at its discretion. Any changes to the policy will be
            communicated to users through email or by posting an updated policy
            on our website.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default RefundAndCancellation;
